import { QuestionTypeMeta } from '../Types/ClassroomAdmission.types';

export const QuestionTypesMETA: QuestionTypeMeta = {
	mcq: {
		expandable: true,
		hasOptions: true,
	},
};
